module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body avaliacoesProjeto"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.loading.formulariosDisponiveis) ? _c('span', [_vm._m(0)]) : _c('span', [(_vm.listaFormulariosDisponiveis.length === 0) ? _c('div', {
    staticClass: "box-header bg-info"
  }, [_vm._v("\n            Não há formulário disponível para avaliação deste projeto " + _vm._s(_vm.numeroProjeto) + "\n          ")]) : _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "row",
    attrs: {
      "title": '<h5>Se desejar enviar um formulário de avaliação para a entidade parceira neste projeto ' + _vm.numeroProjeto + ', então selecione o formulário desejado e clique em Enviar</h5>'
    }
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listaFormulariosDisponiveis,
      "multiple": false,
      "close-on-select": true,
      "placeholder": 'Formulários disponíveis para envio',
      "track-by": "id",
      "label": "nome",
      "selectedLabel": "selecionado",
      "selectLabel": "",
      "deselectLabel": "",
      "name": "formularios_disponiveis",
      "data-vv-as": "formularios_disponiveis"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('table', {
          staticClass: "w100"
        }, [_c('tr', [_c('td', {
          staticClass: "w40"
        }, [_c('span', {
          staticClass: "text-warning text-bold"
        }, [_vm._v(_vm._s(props.option.id) + " ")]), _vm._v(" " + _vm._s(props.option.nome) + " "), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "w20",
          staticStyle: {
            "font-style": "italic"
          }
        }, [_vm._v(_vm._s(_vm._.find(_vm.tipoFormulario, ['codigo', props.option.tipo])['descricao']))]), _vm._v(" "), _c('td', {
          staticClass: "w20"
        }, [_c('span', {
          class: props.option.uso === 0 ? 'text-danger' : 'text-info'
        }, [_vm._v(_vm._s(props.option.uso === 0 ? 'Nenhum' : props.option.uso + ' preenchido' + (props.option.uso > 1 ? 's' : '')))])])])])]
      }
    }, {
      key: "noResult",
      fn: function(props) {
        return [_vm._v("\n                  Não encontrei formulário com este nome\n                ")]
      }
    }], null, false, 1715438566),
    model: {
      value: (_vm.formularioSelecionadoEnvioManual),
      callback: function($$v) {
        _vm.formularioSelecionadoEnvioManual = $$v
      },
      expression: "formularioSelecionadoEnvioManual"
    }
  })], 1), _vm._v(" "), (!_vm._.isNull(_vm.formularioSelecionadoEnvioManual)) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.encaminharFormularioParaEntidade($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Enviar")])], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('br') : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('table', {
    staticClass: "table b-table table-hover table-bordered b-table-stacked-md"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "centralizado w10"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Formulário")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado w20"
  }, [_vm._v("Situação")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('th', {
    staticClass: "centralizado w30"
  }, [_vm._v("Ação")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.avaliacoesProjeto), function(processo, idx) {
    return _c('tr', [_c('td', {
      staticClass: "centralizado"
    }, [_c('strong', [_vm._v(_vm._s(processo.avaliacao.id))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v("\n                " + _vm._s(processo.formularioCadastrado.id + ' - ' + processo.formularioCadastrado.nome)), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm._.find(_vm.tipoFormulario, ['codigo', processo.formularioCadastrado.tipo])['descricao']))])]), _vm._v(" "), _c('td', {
      staticClass: "centralizado"
    }, [(processo.avaliacao.situacao === 'FEITO') ? _c('span', {
      staticStyle: {
        "color": "var(--cor-sucesso)"
      }
    }, [_vm._v("Concluído")]) : (processo.avaliacao.situacao === 'CANCELADO') ? _c('span', {
      staticStyle: {
        "color": "var(--cor-atencao)"
      }
    }, [_vm._v("Cancelado")]) : (processo.avaliacao.situacao === 'EM_EXECUCAO') ? _c('span', {
      staticStyle: {
        "color": "var(--cor-destaque)"
      }
    }, [_vm._v("Em Execução")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "centralizado"
    }, [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [(processo.avaliacao.situacao === 'EM_EXECUCAO' && processo.ultimaTarefa.nome === 'ANALISE') ? _c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'preenche-formulario',
            params: {
              id: _vm._.split(processo.formularioPreenchido.link_acesso, '-')[0]
            }
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gavel",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Validar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['FEITO', 'CANCELADO'], processo.avaliacao.situacao)) ? _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.reativar(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Reativar")]) : _vm._e(), _vm._v(" "), (processo.avaliacao.situacao !== 'CANCELADO') ? _c('g-button-ujarak', {
      directives: [{
        name: "confirm",
        rawName: "v-confirm",
        value: ({
          ok: function (retorno) { return _vm.cancelar(processo.avaliacao.id); },
          cancel: _vm.doNothing,
          message: '<span class=\'avisoAlerta\'>Deseja <b>Cancelar</b> esta avaliação?</span>'
        }),
        expression: "{ok: retorno => cancelar(processo.avaliacao.id), cancel: doNothing, message: '<span class=\\'avisoAlerta\\'>Deseja <b>Cancelar</b> esta avaliação?</span>'}"
      }],
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      }
    }, [_c('i', {
      staticClass: "fa fa-ban",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && processo.avaliacao.situacao === 'EM_EXECUCAO' && _vm._.includes(['SOLICITACAO', 'REVISAO'], processo.ultimaTarefa.nome)) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'preenche-formulario',
            params: {
              id: _vm._.split(processo.formularioPreenchido.link_acesso, '-')[1]
            }
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")])], 1) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'preenche-formulario',
            params: {
              id: _vm._.split(processo.formularioPreenchido.link_acesso, '-')[2]
            }
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Buscando formulários disponíveis para este projeto")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "color": "var(--cor-fraca)"
    }
  }, [_vm._v("Formulários vinculados neste projeto")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e256c0e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/avaliacoesProjeto.vue
// module id = 2006
// module chunks = 2